import React from 'react';
import styled from 'styled-components';

const FooterDiv = styled.div`
  width: 100%;
  background-image: linear-gradient(135deg, #abdcff 0%, #0396ff 100%);
  padding: 20px 20px;
  margin-top: 60px;
  color: #393f4d;
  font-family: 'Helvetica', sans-serif;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
`;

class Footer extends React.Component {
  render() {
    return (
      <FooterDiv>
        <p>
          © 2023 RED RIVER GLAZING INC | 300 43RD ST N FARGO, ND 58102 | (701)
          232-4717 |{' '}
          <a href="mailto:contact@redriverglazing.com">
            contact@redriverglazing.com
          </a>
        </p>
      </FooterDiv>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js